// extracted by mini-css-extract-plugin
export var infoItem = "_n9-2";
export var title = "_n9-0";
export var value = "_n9-1";